// This is a reducer. File location /src/store/reducers/songs.js
import {
    FETCH_SONGS,
    FETCH_SONGS_SUCCESS,
    FETCH_SONGS_FAILED,
    SEARCH_SONGS,
    UPDATED_SELECTED_LANGS,
    CLEAR_SONGS,
} from "../actions/songs";
import fuzzySearchUtil from "../../utilities/fuzzySearch";

const initialState = {
    loadingSongs: true,
    allSongs: [],
    songs: [],
    availableLangs: [],
    selectedLangs: [],
    errorMessage: '',
    // hymnforge version block from the API; null until first successful fetch
    hymnforgeInfo: null,
}

const songs = (state = initialState, action) => {
    switch(action.type) {
        case FETCH_SONGS:
            return {...state, loadingSongs: true}
        case FETCH_SONGS_SUCCESS:
            // Initialize fuzzy search with new songs data
            fuzzySearchUtil.initializeSearch(action.songs);
            return {
                ...state,
                loadingSongs: false,
                availableLangs: action.availableLangs,
                songs: action.songs,
                allSongs: action.songs,
                // Only update hymnforgeInfo when the action includes it (first load).
                // Keeps the existing value on subsequent language-filtered fetches.
                hymnforgeInfo: action.hymnforgeInfo !== undefined
                    ? action.hymnforgeInfo
                    : state.hymnforgeInfo,
            }
        case FETCH_SONGS_FAILED:
            return {...state, loadingSongs: false}
        case SEARCH_SONGS:
            const songs = searchedSongs(action.searchKeyword, state.allSongs)
            return { ...state, songs }
        case UPDATED_SELECTED_LANGS:
            return {...state, selectedLangs: action.langs}
        case CLEAR_SONGS:
            return { ...state, songs: [], allSongs: [] }
        default:
            return state
    }
}

const searchedSongs = (searchKeyword, allSongs) => {
    if (searchKeyword === '') {
        return fuzzySearchUtil.getAllSongs();
    }
    return fuzzySearchUtil.search(searchKeyword);
}

export default songs
